import Popup from 'reactjs-popup'
// import Tooltip from './Tooltip' // adjust path
// import KTSVG from './KTSVG' // adjust path
import {Tooltip} from '../../../../modules/apps/timesheetentry/ComponentTooltip'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

const ViewSyncPop: React.FC<any> = (props: any) => {
  let state2: any // Declare state2 outside the if block
  let state22: any
  if (props.inv_array != 'yes') {
    state2 =
      props.icons.invoice_id != null
        ? {
            user_id: props.user_id,
            project_id: props.project_id,
            view: props.view,
            view1: 'Draft/Open',
            id: props.icons.invoice_id,
            project_name: props.project_name,
            week_start_date: props.week_start_date,
            week_end_date: props.week_end_date,
          }
        : {
            user_id: props.user_id,
            project_id: props.project_id,
            view: props.view,
            project_name: props.project_name,
            week_start_date: props.week_start_date,
            week_end_date: props.week_end_date,
          }
  }

  if (props.inv_array == 'yes') {
    state22 = {
      user_id: props.user_id,
      project_id: props.project_id,
      view: props.view,
      project_name: props.project_name,
      week_start_date: props.week_start_date,
      week_end_date: props.week_end_date,
    }
  }
  const handleOpenInNewTab = (e: any, state: any, url1: any) => {
    e.preventDefault() // Prevent default behavior
    // const url = '/timetracker/invoice/updateinvoice'
    const url = url1
    // Convert the state into query parameters
    const queryString = new URLSearchParams(state).toString()
    // Construct the full URL with query parameters
    const fullUrl = `${url}?${queryString}`
    // Open the URL in a new tab
    window.open(fullUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      {props.inv_array != 'yes' && (
        <Tooltip text={''}>
          <div>
            <Popup
              trigger={
                <button
                  className='btn btn-icon btn-light btn-active-color-primary btn-sm'
                  style={{cursor: 'default'}}
                >
                  {props.icons.netsuite_invoice_id != null ? (
                    <KTSVG path='/media/icons/invoice.svg' className='svg-icon-1 text-success' />
                  ) : props.icons.netsuite_invoice_id == null && props.icons.invoice_id != null ? (
                    <KTSVG
                      path='/media/icons/invoice-pending.svg'
                      className='svg-icon-1 text-warning'
                    />
                  ) : (
                    <KTSVG
                      path='/media/icons/invoice-pending.svg'
                      className='svg-icon-1 text-danger'
                    />
                  )}
                </button>
              }
              position='bottom center'
              on='hover'
              mouseEnterDelay={0}
              mouseLeaveDelay={200}
            >
              {props.icons.netsuite_invoice_id != null || props.icons.invoice_status == 'Open' ? (
                <div className={`p-3 bg-light-success`}>
                  {/* <Link
                      to='/invoice/viewinvoice'
                      state={{
                        user_id: props.user_id,
                        project_id: props.project_id,
                        view: props.view,
                        view1: 'Draft/Open',
                        id: props.icons.invoice_id,
                        project_name: props.project_name,
                        week_start_date: props.week_start_date,
                        week_end_date: props.week_end_date,
                      }}
                      className=''
                    > */}
                  <Link
                    //   key={index}
                    to={`/invoice/viewinvoice`} // Link to the same route
                    onClick={(e) =>
                      handleOpenInNewTab(e, state2, '/timetracker/invoice/viewinvoice')
                    }
                    className=''
                  >
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      #Invoice:{' '}
                      {props.icons.netsuite_invoice_number
                        ? props.icons.netsuite_invoice_number
                        : props.icons.invoice_id}
                    </div>

                    <div className='border-top my-3'></div>

                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Invoice Status: {props.icons.invoice_status}
                    </div>
                    {props.icons.invoice_status == 'Sent to NS' && (
                      <div className='text-gray-900 fs-7 fw-semibold'>
                        NS Status:{' '}
                        {props.icons.netsuite_invoice_status
                          ? props.icons.netsuite_invoice_status
                          : '-'}
                      </div>
                    )}
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Total Amount:{' '}
                      {props.icons.final_amount
                        ? props.icons.final_amount
                        : props.icons.total_amount}
                    </div>
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Invoice Date: {props.icons.invoice_date}
                    </div>
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Due Date: {props.icons.due_date}
                    </div>
                  </Link>
                </div>
              ) : props.icons.netsuite_invoice_id == null && props.icons.invoice_id != null ? (
                <div className='p-3 bg-light-warning'>
                  {/* <Link
                        to='/invoice/updateinvoice'
                        state={{
                          user_id: props.user_id,
                          project_id: props.project_id,
                          view: props.view,
                          view1: 'Draft/Open',
                          id: props.icons.invoice_id,
                          project_name: props.project_name,
                          week_start_date: props.week_start_date,
                          week_end_date: props.week_end_date,
                        }}
                        className=''
                      > */}
                  <Link
                    //   key={index}
                    to={`/invoice/updateinvoice`} // Link to the same route
                    onClick={(e) =>
                      handleOpenInNewTab(e, state2, '/timetracker/invoice/updateinvoice')
                    }
                    className=''
                  >
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      #Invoice:{' '}
                      {props.icons.netsuite_invoice_number
                        ? props.icons.netsuite_invoice_number
                        : props.icons.invoice_id}
                    </div>

                    <div className='border-top my-3'></div>

                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Invoice Status: {props.icons.invoice_status}
                    </div>
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Total Amount:{' '}
                      {props.icons.final_amount
                        ? props.icons.final_amount
                        : props.icons.total_amount}
                    </div>
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Invoice Date: {props.icons.invoice_date}
                    </div>
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      Due Date: {props.icons.due_date}
                    </div>
                  </Link>
                </div>
              ) : (
                <div className='p-3 bg-light-danger'>
                  {/* <Link
                  to='/invoice/addinvoice'
                  state={{
                    user_id: props.user_id,
                    project_id: props.project_id,
                    view: props.view,
                    project_name: props.project_name,
                    week_start_date: props.week_start_date,
                    week_end_date: props.week_end_date,
                  }}
                  className=''
                > */}
                  <Link
                    //   key={index}
                    to={`/invoice/addinvoice`} // Link to the same route
                    onClick={(e) =>
                      handleOpenInNewTab(e, state2, '/timetracker/invoice/addinvoice')
                    }
                    className=''
                  >
                    <div className='text-gray-900 fs-7 fw-semibold'>
                      {/* Last Sync Time: {props.updatedTime} */}
                      Create Invoice
                    </div>

                    {/* <div className='border-top my-3'></div>

                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Invoice Status: {props.icons.invoice_status}
                  </div>
                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Invoice Date: {props.icons.invoice_date}
                  </div>
                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Due Date: {props.icons.due_date}
                  </div> */}
                  </Link>
                </div>
              )}
            </Popup>
          </div>
        </Tooltip>
      )}

      {props.inv_array == 'yes' && (
        <>
          <Tooltip text={''}>
            <div className='d-inline-flex align-items-center gap-3'>
              <Popup
                trigger={
                  props.label == 'label' ? (
                    <button
                      className='btn  btn-active-color-primary btn-sm '
                      style={{whiteSpace: 'pre', cursor: 'default'}}
                    >
                      {props.invoice_status == 'invoiced'
                        ? 'Invoiced'
                        : props.invoice_status == 'pending_invoiced'
                        ? 'Partially Invoiced'
                        : 'Not Invoiced'}
                    </button>
                  ) : (
                    <button
                      className='btn btn-icon  btn-active-color-primary btn-sm cursor-pointer'
                      style={{cursor: 'default'}}
                    >
                      {props.invoice_status == 'invoiced' ? (
                        <KTSVG
                          path='/media/icons/invoice.svg'
                          className='svg-icon-1 text-success'
                        />
                      ) : props.invoice_status == 'pending_invoiced' ? (
                        <KTSVG
                          path='/media/icons/invoice-pending.svg'
                          className='svg-icon-1 text-warning'
                        />
                      ) : (
                        <KTSVG
                          path='/media/icons/invoice-pending.svg'
                          className='svg-icon-1 text-danger'
                        />
                      )}
                    </button>
                  )
                }
                position='bottom center'
                on='hover'
                mouseEnterDelay={0}
                mouseLeaveDelay={200}
              >
                {props?.icons?.length > 0 ? (
                  props?.icons?.map((inv_key: any) => {
                    let state21 =
                      inv_key.invoice_id != null
                        ? {
                            user_id: props.user_id,
                            project_id: props.project_id,
                            view: props.view,
                            view1: 'Draft/Open',
                            id: inv_key.invoice_id,
                            project_name: props.project_name,
                            week_start_date: props.week_start_date,
                            week_end_date: props.week_end_date,
                          }
                        : {
                            user_id: props.user_id,
                            project_id: props.project_id,
                            view: props.view,
                            project_name: props.project_name,
                            week_start_date: props.week_start_date,
                            week_end_date: props.week_end_date,
                          }
                    return (
                      <>
                        {inv_key.netsuite_invoice_id != null || inv_key.invoice_status == 'Open' ? (
                          // <div className='p-3'>
                          <div className={`p-3 bg-light-success`}>
                            {/* <Link
                  to='/invoice/viewinvoice'
                  state={{
                    user_id: props.user_id,
                    project_id: props.project_id,
                    view: props.view,
                    view1: 'Draft/Open',
                    id: inv_key.invoice_id,
                    project_name: props.project_name,
                    week_start_date: props.week_start_date,
                    week_end_date: props.week_end_date,
                  }}
                  className=''
                > */}
                            <Link
                              //   key={index}
                              to={`/invoice/viewinvoice`} // Link to the same route
                              onClick={(e) =>
                                handleOpenInNewTab(e, state21, '/timetracker/invoice/viewinvoice')
                              }
                              className=''
                            >
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                #Invoice:{' '}
                                {inv_key.netsuite_invoice_number
                                  ? inv_key.netsuite_invoice_number
                                  : inv_key.invoice_id}
                              </div>

                              <div className='border-top my-3'></div>

                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Invoice Status: {inv_key.invoice_status}
                              </div>
                              {inv_key.invoice_status == 'Sent to NS' && (
                                <div className='text-gray-900 fs-7 fw-semibold'>
                                  NS Status:{' '}
                                  {inv_key.netsuite_invoice_status
                                    ? inv_key.netsuite_invoice_status
                                    : '-'}
                                </div>
                              )}
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Total Amount:{' '}
                                {inv_key.final_amount ? inv_key.final_amount : inv_key.total_amount}
                              </div>
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Invoice Date: {inv_key.invoice_date}
                              </div>
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Due Date: {inv_key.due_date}
                              </div>
                            </Link>
                          </div>
                        ) : inv_key.netsuite_invoice_id == null && inv_key.invoice_id != null ? (
                          // <div className='p-3'>
                          <div className='p-3 bg-light-warning'>
                            {/* <Link
                  to='/invoice/updateinvoice'
                  state={{
                    user_id: props.user_id,
                    project_id: props.project_id,
                    view: props.view,
                    view1: 'Draft/Open',
                    id: inv_key.invoice_id,
                    project_name: props.project_name,
                    week_start_date: props.week_start_date,
                    week_end_date: props.week_end_date,
                  }}
                  className=''
                > */}
                            <Link
                              //   key={index}
                              to={`/invoice/updateinvoice`} // Link to the same route
                              onClick={(e) =>
                                handleOpenInNewTab(e, state21, '/timetracker/invoice/updateinvoice')
                              }
                              className=''
                            >
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                #Invoice:{' '}
                                {inv_key.netsuite_invoice_number
                                  ? inv_key.netsuite_invoice_number
                                  : inv_key.invoice_id}
                              </div>

                              <div className='border-top my-3'></div>

                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Invoice Status: {inv_key.invoice_status}
                              </div>
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Total Amount:{' '}
                                {inv_key.final_amount ? inv_key.final_amount : inv_key.total_amount}
                              </div>
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Invoice Date: {inv_key.invoice_date}
                              </div>
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                Due Date: {inv_key.due_date}
                              </div>
                            </Link>
                          </div>
                        ) : (
                          // <div className='p-3'>
                          <div className={`p-3 bg-light-danger`}>
                            {/* <div className='p-3 bg-light-danger'> */}
                            {/* <Link
                  to='/invoice/addinvoice'
                  state={{
                    user_id: props.user_id,
                    project_id: props.project_id,
                    view: props.view,
                    project_name: props.project_name,
                    week_start_date: props.week_start_date,
                    week_end_date: props.week_end_date,
                  }}
                  className=''
                > */}
                            <Link
                              //   key={index}
                              to={`/invoice/addinvoice`} // Link to the same route
                              onClick={(e) =>
                                handleOpenInNewTab(e, state21, '/timetracker/invoice/addinvoice')
                              }
                              className=''
                            >
                              <div className='text-gray-900 fs-7 fw-semibold'>
                                {/* Last Sync Time: {props.updatedTime} */}
                                Create Invoice
                              </div>

                              {/* <div className='border-top my-3'></div>

                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Invoice Status: {inv_key.invoice_status}
                  </div>
                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Invoice Date: {inv_key.invoice_date}
                  </div>
                  <div className='text-gray-900 fs-7 fw-semibold'>
                    Due Date: {inv_key.due_date}
                  </div> */}
                            </Link>
                          </div>
                        )}
                      </>
                    )
                  })
                ) : (
                  // <div className='p-3'>
                  <div className={`p-3 bg-light-danger`}>
                    <Link
                      to={`/invoice/addinvoice`}
                      onClick={(e) =>
                        handleOpenInNewTab(e, state22, '/timetracker/invoice/addinvoice')
                      }
                      className=''
                    >
                      <div className='text-gray-900 fs-7 fw-semibold'>Create Invoice</div>
                    </Link>
                  </div>
                )}
              </Popup>
            </div>
          </Tooltip>
          {/* </>
              )
            })} */}
        </>
      )}
    </>
  )
}

export default ViewSyncPop
